import { useRef as s, useCallback as o } from "react";
import { assertActionId as u } from "../system/assertions.js";
import "../system/constants.js";
import "../key/constants.js";
function A(e) {
  const r = s(/* @__PURE__ */ new Map()), c = o((t) => r.current.get(t), []), i = o(
    (t, n) => (u(e, t, "InputSystemProvider.registerAction"), r.current.set(t, n), () => {
      r.current.get(t) === n && r.current.delete(t);
    }),
    [e]
  );
  return { getAction: c, registerAction: i };
}
export {
  A as useActionRegistry
};
